// src/UpdateSeatInfo.js
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

function UpdateSeatInfo({ closeModal, showNotification }) {
  const [theaterNumber, setTheaterNumber] = useState('');
  const [seatNumber, setSeatNumber] = useState('');
  const [comment, setComment] = useState('');
  const [date, setDate] = useState(new Date()); // Initialize with the current date
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    setIsSubmitting(true);
    try {
      if (!theaterNumber.trim() || !seatNumber.trim() || !comment.trim()) {
        showNotification('Please fill in all required fields.', 'error');
        setIsSubmitting(false);
        return;
      }

      await addDoc(collection(db, 'issues'), {
        theaterNumber: Number(theaterNumber),
        seatNumber: seatNumber.trim(), // Store seatNumber as a string
        comment: comment.trim(),
        dateReported: date.toISOString().split('T')[0],
        dateResolved: null,
        commentResolved: null,
        createdAt: serverTimestamp(),
        resolved: false,
      });
      showNotification('Issue reported successfully.', 'success');
      closeModal();
    } catch (error) {
      console.error('Error adding document: ', error);
      showNotification('Failed to report issue. Please try again.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="number"
        value={theaterNumber}
        onChange={(e) => setTheaterNumber(e.target.value)}
        placeholder="Theater Number"
        required
      />
      <input
        type="text"
        value={seatNumber}
        onChange={(e) => setSeatNumber(e.target.value)}
        placeholder="Seat Number"
        required
      />
      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder="Comment"
        required
      ></textarea>

      <div style={{ marginTop: '10px' }}>
        <label htmlFor="date-picker">Select Date:</label>
        <DatePicker
          id="date-picker"
          selected={date}
          onChange={(date) => setDate(date)}
          dateFormat="yyyy-MM-dd"
          className="date-picker-input"
          popperPlacement="auto"
        />
      </div>

      <button type="submit" disabled={isSubmitting}>Submit</button>
    </form>
  );
}

export default UpdateSeatInfo;
